// Workflow Status Configurable on UI
export const STATUS_MAP = {
  "Not_Started": "Not Started",
  "First_Review": "First Review",
  "QA_Review": "Speaker Verified",
  "Compliance": "First Draft Final",
  "Publication": "Human Perfect",
}
const STATUS_COLORS = {
  "Not_Started": '#9297A0',
  "First_Review": '#C13E7B',
  "QA_Review": '#6B65BD',
  "Compliance": '#1F75C1',
  "Publication": '#20B662',
};
export const PRIORITY_MAP = {
  1: 'Critical',
  2: 'Very High',
  3: 'High',
  4: 'Moderate',
  5: 'Low',
  6: 'Lowest'
};

export const PARTNER_IDS = [
  "9bf61454-565b-4b39-b085-f420a116c97e", // Quartr
  "2a9fe8a6-9ace-49fb-b04c-8a936acfe6fd", // Aiera
  "f5c3c46f-f6a6-4436-b35b-f160d80f4a16", // Tegus
  "d71f9036-ec71-4819-ac1e-807b67d53540", // Third Bridge
]

export const PARTNER_CODE_NAMES = {
  "9bf61454-565b-4b39-b085-f420a116c97e": "MANTIS", // Quartr
  "2a9fe8a6-9ace-49fb-b04c-8a936acfe6fd": "CRICKET", // Aiera
  "f5c3c46f-f6a6-4436-b35b-f160d80f4a16": "BEETLE", // Tegus
  "d71f9036-ec71-4819-ac1e-807b67d53540": "SPIDER", // Third Bridge
};

export const PARTNER_CONFIG = [
  {
    id: "9bf61454-565b-4b39-b085-f420a116c97e",
    name: "Quartr",
    alias: "Mantis",
  },
  {
    id: "2a9fe8a6-9ace-49fb-b04c-8a936acfe6fd",
    name: "Aiera",
    alias: "Cricket",
  },
  {
    id: "f5c3c46f-f6a6-4436-b35b-f160d80f4a16",
    name: "Tegus",
    alias: "Beetle",
  },
  {
    id: "d71f9036-ec71-4819-ac1e-807b67d53540",
    name: "Third Bridge",
    alias: "Spider",
  },
];

export const PRIORITY_MAP_SELECT = Object.entries(PRIORITY_MAP).map(([value, label]) => ({ value: Number(value), label }));
// UHP (Ultra High Priority) title patterns
export const UHP_TITLE_PATTERNS = ["insight-venture-", "aiec", "concierge"];

/**
 * Check if a title matches UHP (Ultra High Priority) patterns
 * @param {string} title - The workflow title to check
 * @returns {boolean} True if title matches any UHP pattern
 */
export const isUhpTitle = (title) => {
  if (!title) return false;
  const lowerTitle = title.toLowerCase();
  return UHP_TITLE_PATTERNS.some(pattern => lowerTitle.includes(pattern));
};

// Legacy export for backwards compatibility
export const ULTRA_HIGH_PRIORITY_TEXT = "insight-venture-";
export const STATUS_MAP_SELECT = Object.entries(STATUS_MAP).map(([value, label]) => ({ value, label }));
export const STATUS_OPTIONS = STATUS_MAP_SELECT.map(option => ({
  ...option,
  color: STATUS_COLORS[option.value]
}));
export const getFormattedDuration = (timeInSeconds) => {
  try {
    const hours = String(Math.floor(timeInSeconds / (60 * 60))).padStart(2, '0');
    const minutes = String(Math.floor((timeInSeconds % (60 * 60)) / 60)).padStart(2, '0');
    const seconds = String(Math.floor(timeInSeconds % 60)).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  } catch (e) {
    // noop
  }
};

export const isAieraFile = (assignees) => {
  const AIERA_USER_ID = "2a9fe8a6-9ace-49fb-b04c-8a936acfe6fd";

  if (!assignees || !Array.isArray(assignees)) {
    return false;
  }

  return assignees.includes(AIERA_USER_ID);
};

export const getPartnerCodeName = (assignees) => {
  if (!assignees || !Array.isArray(assignees)) {
    return "";
  }

  let codeName = "";

  assignees.forEach((assignee) => {
    if (PARTNER_CODE_NAMES[assignee] && !codeName) {
      codeName = PARTNER_CODE_NAMES[assignee];
    }
  });

  return codeName;
};

export const getFileTag = (assignees, jobType, role) => {
  let tag = "";

  if (role === "ADMIN") {
    const aieraFile = isAieraFile(assignees);

    if (aieraFile) {
      tag = `[Aiera ${jobType}] `;
    }
  } else {
    const partnerCodeName = getPartnerCodeName(assignees);

    if (partnerCodeName) {
      tag = `[${partnerCodeName}] `;
    }
  }

  return tag;
};
